import { navigate, RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';
import Button from '../../../../components/Button';
import DatePicker from '../../../../components/DatePicker';
import { FormConsumer, FormProvider, IFormAttributes } from '../../../../components/Forms';
import Input from '../../../../components/Input';
import { IAdminEventActions } from '../../../../store/admin/events/actions';
import { IAdminEvent } from '../../../../store/admin/events/store';

interface IState {
  invalidEvent: boolean;
  invalidEventMessage: string;
  buttonAction: string;
}

enum ButtonType {
  goToDashboard = 'goToDashboard',
  goToSetupRounds = 'goToSetupRounds'
}

interface IProps extends RouteComponentProps {
  actions: { adminEvents: IAdminEventActions };
  clubID: number;
}

class CreateFirstClubEvent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      buttonAction: '',
      invalidEvent: false,
      invalidEventMessage: ''
    };
  }

  public toggleButtonAction = (type: string) => (): void => {
    if (type === 'dashboard') {
      this.setState({
        buttonAction: ButtonType.goToDashboard
      });
    } else {
      this.setState({
        buttonAction: ButtonType.goToSetupRounds
      });
    }
  };

  public onSubmit = async (data: Partial<IAdminEvent>) => {
    const { clubID, actions } = this.props;
    const response = await actions.adminEvents.create(clubID, data);
    if (response.errors && response.errors.events) {
      this.setState({
        invalidEvent: true,
        invalidEventMessage: response.errors.events.msg || ''
      });
    } else {
      if (this.state.buttonAction === ButtonType.goToSetupRounds) {
        // TODO: Add real link to setup rounds
        return navigate(`/admin/events`);
      }
      if (this.state.buttonAction === ButtonType.goToDashboard) {
        return navigate(`/admin/events`);
      }
    }
  };

  public render(): JSX.Element {
    return (
      <div className="wrapper create-first-club-container">
        <div>
          <FormProvider
            defaultValues={{}}
            onSubmit={this.onSubmit}
            validations={{
              end: ['required', 'date'],
              name: 'required',
              start: ['required', 'date']
            }}
          >
            <FormConsumer>
              {({ values, formActions: { setValue }, errors }: IFormAttributes) => (
                <div className="create-first-club-form form">
                  <h1>
                    CREATE YOUR <br />
                    CLUB'S FIRST EVENT
                  </h1>
                  <p>
                    All you need to do is give the event a name and dates. If you want to add more
                    details, keep it going. Otherwise save it and come back later to finish the
                    details.
                  </p>

                  <Input
                    label="NAME YOUR EVENT"
                    id="event-name"
                    type="text"
                    value={values.name}
                    onChange={setValue('name')}
                    hasError={errors.name}
                    errorMessage="Event Name cannot be empty"
                    fullWidth={true}
                  />
                  <div className="event-info-wrapper">
                    <DatePicker
                      id="event-start"
                      label="WHAT DAY DOES IT START?"
                      placeholder="01/01/2019"
                      value={values.start}
                      onChange={setValue('start')}
                      onError={setValue('start')}
                    />
                    <DatePicker
                      id="event-end"
                      label="WHEN DOES IT END?"
                      placeholder="01/25/2019"
                      value={values.end}
                      onChange={setValue('end')}
                      onError={setValue('end')}
                    />
                  </div>

                  <Button
                    onClick={this.toggleButtonAction('rounds')}
                    variant="contained"
                    color="primary"
                    disabled={errors.FORM}
                    type="submit"
                    className="button setup-rounds button-shadow"
                  >
                    SET UP ROUND DETAILS
                  </Button>
                  <Button
                    onClick={this.toggleButtonAction('dashboard')}
                    variant="text"
                    type="submit"
                    color="primary"
                    className="button save-and-exit"
                  >
                    SAVE AND GO TO DASHBOARD
                  </Button>
                </div>
              )}
            </FormConsumer>
          </FormProvider>
        </div>
      </div>
    );
  }
}

export { CreateFirstClubEvent };
